export default __webpack_public_path__ + "static/media/regulatory--no-vehicles-carrying-dangerous-water-pollutants--g2.93eebcbf.png";